"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FooterUtility = require("./FooterUtility.style");

var FooterUtility = function FooterUtility(_ref) {
  var copyrightText = _ref.copyrightText,
      links = _ref.links,
      rest = _objectWithoutProperties(_ref, ["copyrightText", "links"]);

  return /*#__PURE__*/_react.default.createElement(_FooterUtility.UtilityContainer, rest, /*#__PURE__*/_react.default.createElement(_FooterUtility.Wrapper, null, links && links.length > 0 && /*#__PURE__*/_react.default.createElement(_FooterUtility.UtilityNav, null, links.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_FooterUtility.UtilityNavLink, {
      key: link.label,
      size: "xsmall",
      to: link.url
    }, link.label);
  })), /*#__PURE__*/_react.default.createElement(_FooterUtility.Copyright, {
    size: "xsmall"
  }, "\xA9 ", copyrightText)));
};

FooterUtility.propTypes = {
  copyrightText: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }))
};
FooterUtility.defaultProps = {
  copyrightText: '',
  links: []
};
var _default = FooterUtility;
exports.default = _default;